import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import { FirebaseProvider } from './components/FirebaseProvider';
import { ThemeProvider } from './contexts/ThemeContext';

function renderApp() {
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Failed to find the root element');

  createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <FirebaseProvider>
          <AuthProvider>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </AuthProvider>
        </FirebaseProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

if (window && 'cordova' in window) {
  document.addEventListener('deviceready', () => {
    console.log('[Cordova] deviceready triggered');
    renderApp();
  }, false);
} else {
  renderApp();
}
